import "./css/wj.scss";

import { initNav } from "./js/components/nav.js";
import { initFilterPopover } from "./js/components/filter-popover.js";
import { initProviderFilter } from "./js/components/provider-filter.js";
import { initCmsContentFixer } from "./js/components/cmscontent/wj-cms-content-fixer.js";

import { checkInputWidgetValidation } from "./js/modules/general/inputwidget.validation.js";
import { initHeatingElectricityWidget } from "./js/modules/general/heating.electricity.widget.js";

import { addressSolverWidget } from "./js/components/address-solver.js";
import { initWJProviderReviews } from "./js/components/resultitem/wj-provider-reviews.js";
import { initCancellationLetter } from "./js/components/cancellation-letter.js";

initWJProviderReviews();

window.addEventListener("DOMContentLoaded", () => {
  let inputWidget, heatingWidget, addressSolver;

  initNav();
  initProviderFilter()
  initCmsContentFixer();
  initFilterPopover();
  initCancellationLetter();

  if ((inputWidget = document.querySelector(".js-input-widget"))) {
    new checkInputWidgetValidation(inputWidget);
  }

  if ((heatingWidget = document.querySelector(".js-heating-electricity-widget"))) {
    initHeatingElectricityWidget(heatingWidget);
  }

  if ((addressSolver = document.getElementById("address-solver"))) {
    new addressSolverWidget(addressSolver);
  }
});
